module.exports = __webpack_public_path__ + "img/download_icon.1dc98c26.svg";